<template>
    <v-container>
        <loader v-if="isloading"></loader>
        <v-card shaped class="mx-md-4 my-md-4 pa-4">
            <v-row>
                <v-col cols="12">
                    <v-toolbar
                        flat
                        color="#1d2735"
                        dark
                        style="border-radius: 5px"
                    >
                        <v-icon class="white--text" style="font-size: 45px"
                            >mdi-account-supervisor-circle</v-icon
                        >
                        <pre><v-toolbar-title><h2>Crear producto <span v-if="producto.nro != null">{{ producto.nro }}</span></h2></v-toolbar-title></pre>
                    </v-toolbar>
                    <v-form class="mt-3">
                        <v-row justify="end">
                            <v-tooltip right style="margin-bottom: 5px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        fab
                                        dense
                                        to="lista-productos"
                                        :loading="isloading"
                                        :disabled="isloading"
                                        color="blue"
                                        class="mt-4 mx-3"
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        <v-icon class="white--text"
                                            >mdi-arrow-left-bold-outline</v-icon
                                        >
                                    </v-btn>
                                </template>
                                <span>Volver</span>
                            </v-tooltip>
                        </v-row>
                        <form ref="form">
                            <input
                                :value="$route.query.id"
                                v-if="$route.query.id != null"
                                name="id"
                                style="display: none"
                            />
                            <v-row>
                                <v-col cols="12" md="4">
                                    <v-text-field
                                        v-model="producto.titulo"
                                        label="Título"
                                        name="titulo"
                                        hint="Título que se mostrará en los selects"
                                        persistent-hint
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field
                                        v-model="producto.nombre"
                                        label="Nombre"
                                        name="nombre"
                                        required
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field-comma
                                        type="number"
                                        v-model="producto.precio"
                                        label="Precio"
                                        name="precio"
                                        suffix="€"
                                        required
                                    ></v-text-field-comma>
                                </v-col>

                                <v-col cols="12" md="4">
                                    <v-text-field-comma
                                        type="number"
                                        v-model="producto.precio_hora_normal"
                                        label="Precio hora normal"
                                        name="precio_hora_normal"
                                        suffix="€"
                                        required
                                    ></v-text-field-comma>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field-comma
                                        type="number"
                                        v-model="producto.precio_hora_extra"
                                        label="Precio hora nocturna"
                                        name="precio_hora_extra"
                                        suffix="€"
                                        required
                                    ></v-text-field-comma>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field-comma
                                        type="number"
                                        v-model="producto.precio_hora_festivo"
                                        label="Precio hora festivo"
                                        name="precio_hora_festivo"
                                        suffix="€"
                                        required
                                    ></v-text-field-comma>
                                </v-col>

                                <v-col cols="12" md="6">
                                    <v-switch
                                        label="Ocultar de intereses"
                                        :true-value="1"
                                        :false-value="0"
                                        v-model="producto.hide"
                                    >
                                    </v-switch>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-file-input
                                        v-model="imagen"
                                        label="Imagen"
                                        name="imagen"
                                        required
                                    ></v-file-input>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <img
                                        height="141"
                                        width="251"
                                        style="
                                            background-color: #dddddd;
                                            object-fit: contain;
                                        "
                                        :src="getImage"
                                    />
                                </v-col>
                            </v-row>
                            <v-col cols="12">
                                <v-textarea
                                    outlined
                                    name="descripcion"
                                    :label="'Descripción'"
                                    v-model="producto.descripcion"
                                >
                                </v-textarea>
                            </v-col>
                        </form>
                        <v-row>
                            <v-col cols="12">
                                <router-link to="lista-productos">
                                    <v-btn color="red" class="white--text mr-2">
                                        Cancelar
                                    </v-btn>
                                </router-link>
                                <v-btn
                                    v-if="!producto.id"
                                    @click="saveproducto"
                                    :disabled="isloading"
                                    color="success"
                                    class="white--text mr-2"
                                    >Guardar</v-btn
                                >
                                <v-btn
                                    v-if="producto.id && rol != 4 && rol != 5"
                                    @click="saveproducto"
                                    :disabled="isloading"
                                    color="success"
                                    class="white--text mr-2"
                                    >Actualizar</v-btn
                                >
                                <v-btn
                                    v-if="producto.id && rol != 4 && rol != 5"
                                    @click="
                                        isDeleteProductoDialogVisible = true
                                    "
                                    :disabled="isloading"
                                    color="red"
                                    class="white--text"
                                    >Eliminar</v-btn
                                >
                            </v-col>
                        </v-row>
                    </v-form>
                </v-col>
            </v-row>
        </v-card>

        <!-- Confirmacion de creacion/edicion de familia-->
        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Crear/Editar familia
                </v-card-title>
                <v-card-text style="text-align: center">
                    <v-text-field
                        v-model="familia.nombre"
                        label="Nombre"
                        required
                    ></v-text-field>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog = false;
                            familia.id = null;
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn
                        v-if="familia.id"
                        color="success"
                        large
                        @click="updateFamilia()"
                        >Modificar</v-btn
                    >
                    <v-btn v-else color="success" large @click="createFamilia()"
                        >Guardar</v-btn
                    >

                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <DeleteDialog
            v-model="isDeleteProductoDialogVisible"
            @delete="deleteproducto"
        ></DeleteDialog>

        <!-- En desuso-->
        <!-- Confirmacion de eliminacion de producto-->
        <!-- <v-dialog v-model="delete_dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>

                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog = false;
                            familia.id = null;
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deleteFamilia()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog> -->
    </v-container>
</template>

<script>
import DeleteDialog from "../../../components/general/dialogs/DeleteDialog.vue";
export default {
    components: {
        DeleteDialog,
    },
    data() {
        return {
            isDeleteProductoDialogVisible: false,
            imagen: null,
            menu: false,
            dialog: false,
            canal: {
                id: null,
                nombre: null,
            },
            delete_dialog: false,
            producto: {
                id: null,
                titulo: "",
                precio: "",
                precio_hora_normal: 0,
                precio_hora_extra: 0,
                precio_hora_festivo: 0,
                precio: "",
                idFamilia: -1,
                id_canal: null,
                cuenta: "",
            },
            familias: [],
            familia: {
                id: null,
                nombre: "",
            },
            nueva: 0,
            cuentas: [],
        };
    },
    watch: {
        menu(val) {
            val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
        },
    },
    created() {
        this.getFamilias();
        if (this.$route.query.id) {
            this.getproducto(this.$route.query.id);
        }
        this.getCuentas();
    },
    methods: {
        //metodos de pago

        //estado
        updateEstadoS(index) {
            this.canal = this.canales[index];
        },
        deleteEstado(id) {
            axios.post("api/deleteCanales", { id: id }).then(
                (res) => {
                    this.getCanales();
                    this.delete_dialog = false;
                    this.producto.id_canal = null;
                },
                (res) => {}
            );
        },
        //funciones del Crud de estado
        updatethisEstado(id) {
            this.producto.id_canal = id;
        },
        createEstado() {
            axios.post("api/savecanales", this.canal).then(
                (res) => {
                    this.getCanales();
                    this.canal = {};
                    this.dialog = false;
                },
                (res) => {}
            );
        },
        updateEstado() {
            axios.post("api/savecanales", this.canal).then(
                (res) => {
                    this.getCanales();
                    this.canal = {};

                    this.dialog = false;
                },
                (res) => {}
            );
        },
        getCanales() {
            this.$store.dispatch("getCanales", this);
        },
        getproducto(producto_id) {
            axios.get(`api/getproducto/${producto_id}`).then(
                (res) => {
                    this.producto = res.data;
                    this.producto.cuenta = res.data.cuenta_contable.numero;
                },
                (res) => {}
            );
        },
        updateproducto() {
            let data = new FormData(this.$refs.form);
            data.append("hide", this.producto.hide);
            axios
                .post("api/update-producto", data)
                .then((res) => {
                    this.$router.push("lista-productos");
                })
                .catch((error) => {
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Algo salió mal");
                    }
                });
        },
        saveproducto() {
            let data = new FormData(this.$refs.form);
            data.append("hide", this.producto.hide);
            axios
                .post("api/save-producto", data)
                .then((res) => {
                    this.$router.push("lista-productos");
                })
                .catch((error) => {
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Algo salió mal");
                    }
                });
        },
        deleteproducto() {
            axios.post("api/delete-producto", { id: this.producto.id }).then(
                (res) => {
                    this.isDeleteProductoDialogVisible = false;
                    this.$router.push("lista-productos");
                },
                (res) => {}
            );
        },
        deleteFamilia() {
            axios.post("api/delete-familia", { id: this.familia.id }).then(
                (res) => {
                    this.getFamilias();
                    this.delete_dialog = false;
                    this.producto.idFamilia = null;
                },
                (res) => {}
            );
        },
        createFamilia() {
            axios.post("api/save-familia", this.familia).then(
                (res) => {
                    this.getFamilias();
                    this.dialog = false;
                },
                (res) => {}
            );
        },
        updateFamilia() {
            //console.log(this.familia);
            axios.post("api/update-familia", this.familia).then(
                (res) => {
                    this.getFamilias();
                    this.dialog = false;
                },
                (res) => {}
            );
        },

        save(date) {
            this.$refs.menu.save(date);
        },
        getFamilias() {
            axios.get(`api/getfamilias`).then(
                (res) => {
                    let data = res.data;
                    this.familias = data.Familias;
                    //console.log(this.familias);
                },
                (res) => {}
            );
        },
        openDeleteDialog(id) {
            this.familia.id = id;
            this.delete_dialog = true;
        },
        openDialog() {
            this.familia.id = null;
            this.familia.nombre = "";
            this.dialog = true;
        },
        openEditDialog(id, nombre) {
            this.familia.id = id;
            this.familia.nombre = nombre;
            this.dialog = true;
        },

        // Get cuentas contables
        getCuentas() {
            let prefix = 701;
            axios.get(`api/get-cuentas/${prefix}`).then(
                (res) => {
                    this.cuentas = res.data.success;

                    let numero = 0;
                    this.cuentas.forEach((element) => {
                        if (numero < element.numero) {
                            numero = element.numero;
                        }
                    });

                    this.producto.cuenta = parseInt(numero) + 1;
                },
                (res) => {}
            );
        },
    },
    filters: {},

    computed: {
        rol: function () {
            return localStorage.getItem("role");
        },
        getImage() {
            if (this.imagen != null) {
                return URL.createObjectURL(this.imagen);
            } else {
                return `api/getproducto-image/${this.$route.query.id}`;
            }
        },
        isloading() {
            return this.$store.getters.getloading;
        },
        canales() {
            return this.$store.getters.getcanales;
        },
    },
};
</script>
